export const AUDIENCES = ["Marque / Boutique", "Hôtel / Lieu culturel", "Entreprise / Collectivité", "Particulier / Mariage"];

export const POLES = [
  {
    id: "personnaliser",
    name: "Personnaliser",
    tagline: "Sneakers, bouteilles, bijoux, cuir — chaque objet devient une pièce unique.",
    prestations: [
      { slug: "customisation", title: "Customisation", index: "01" },
      { slug: "bottle-custom", title: "Bottle Custom", index: "02" },
      { slug: "objets-bijoux", title: "Objets & Bijoux", index: "03" },
      { slug: "feuille-or", title: "Feuille d'Or", index: "04" },
    ],
  },
  {
    id: "peindre",
    name: "Peindre",
    tagline: "Textile, murs, toiles — l'art prend vie sur tous les supports.",
    prestations: [
      { slug: "peinture-textile", title: "Peinture sur textile", index: "05" },
      { slug: "peinture-murale", title: "Peinture murale", index: "06" },
      { slug: "live-painting", title: "Live Painting", index: "07" },
    ],
  },
  {
    id: "transmettre",
    name: "Transmettre",
    tagline: "Ateliers et workshops pour créer, expérimenter, partager.",
    prestations: [
      { slug: "workshops", title: "Workshops", index: "08" },
      { slug: "ateliers-collage", title: "Ateliers Collage", index: "09" },
    ],
  },
];

export const PRESTATION_TITLES = [
  "Customisation",
  "Bottle Custom",
  "Objets & Bijoux",
  "Feuille d'Or",
  "Peinture sur textile",
  "Peinture murale",
  "Live Painting",
  "Workshops",
  "Ateliers Collage",
  "Autre projet sur mesure",
];

export const AUDIENCE_CARDS = [
  { title: "Marques & boutiques", text: "Activations produit, personnalisation en boutique, collaborations exclusives." },
  { title: "Hôtels & lieux culturels", text: "Fresques, identité visuelle, œuvres pérennes ou événementielles." },
  { title: "Entreprises & collectivités", text: "Team building créatif, ateliers, animations lors d'événements corporate." },
  { title: "Particuliers & mariages", text: "Pièces uniques, cadeaux personnalisés, moments artistiques mémorables." },
];

export const MARQUEE_ITEMS = [
  "CUSTOMISATION",
  "FRESQUES",
  "LIVE PAINTING",
  "WORKSHOPS",
  "BOTTLE CUSTOM",
  "FEUILLE D'OR",
  "PEINTURE SUR TEXTILE",
  "OBJETS & BIJOUX",
  "ATELIERS COLLAGE",
];

export const REFERENCE_LOGOS = [
  "Adidas",
  "POSCA",
  "Galeries Lafayette Paris",
  "La Samaritaine",
  "Printemps",
  "Citadium",
  "JD",
  "W Hotels",
  "Le Royal Monceau – Raffles Paris",
  "Quai 54",
  "Palais des Congrès de Paris",
  "BRED Banque Populaire",
  "Fouquet's Paris",
  "Festival de Cannes",
];

export const REFERENCE_LOGOS_FULL = [
  "Festival de Cannes", "Adidas", "POSCA", "Fondation Mode", "JD", "Shinzo Paris", "Citadium",
  "Son of a Sneaker", "Calzedonia", "Palais des Congrès de Paris", "Galeries Lafayette",
  "World Streetball Championship Quai 54", "BRED Banque Populaire", "Sneakers Summit",
  "La Samaritaine", "Artsper", "Printemps", "Grand Rex", "Élysée Paris", "La Gazette Drouot",
  "Maison de l'Amérique latine", "Compagnie Française de l'Orient et de la Chine",
  "W.A Magic of Art", "USA Golf", "ABP Concept", "San Marina", "Westfield", "Altan", "Savoiexpo",
  "Fouquet's Paris", "Ville de Gennevilliers", "Daömey", "Le Royal Monceau – Raffles Paris",
  "Boom Boom Villette", "Legacy Store", "W Hotels", "D.U.C", "LADC Paris", "Mon Atelier en Ville",
  "Rosyne", "J. Vaudran Design", "G-Shock", "Makolett", "Espace Culturel et Social Aimé Césaire",
  "Ymja Grillz", "Micha Paris", "Luxor Las Vegas", "Bob's Food Court", "Aéroville",
  "Valet de Pique", "Krystel Ann Art", "Marie & Jo", "CLV77",
];

export const REFERENCE_ARTISTS = [
  "Booba", "Cristiano Ronaldo", "Young Ma", "Gims", "X-Zibit", "Fianso",
  "Seth Gueko", "Abdallah", "Stalley", "Keros'n", "Kalash", "Inès Reg",
];

export const KEY_FIGURES = [
  { value: "5 000+", label: "projets de personnalisation réalisés" },
  { value: "9", label: "disciplines artistiques maîtrisées" },
  { value: "50+", label: "marques et institutions accompagnées" },
  { value: "Paris", label: "basé, disponible partout en France" },
];

export const DIRECTORS = [
  {
    name: "Jules Garin",
    role: "Directeur créatif",
    handle: "@artwhos",
    site: "artwhos.fr",
    siteUrl: "https://artwhos.fr",
    bio: "Peintre et performeur, il signe le geste et la couleur du studio : customisation, fresques et live painting.",
  },
  {
    name: "Andréia Farias",
    role: "Directrice artistique",
    handle: "@_impar_",
    site: "impar.site",
    siteUrl: "https://impar.site",
    bio: "Elle orchestre l'univers visuel du studio : direction artistique, scénographie et ateliers de transmission.",
  },
];

export const CONTACT_EMAIL = "contact@newcreationstudio.fr";
export const CONTACT_PHONE = "+33 6 99 20 41 88";
export const CONTACT_PHONE_LINK = "tel:+33699204188";

export const PLACEHOLDER_GALLERY = [
  {
    id: "ph-1",
    type: "image",
    title: "Sneakers customisées",
    url: "https://images.unsplash.com/photo-1787008231761-ce670792908a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwzfHxwYWludGVkJTIwc25lYWtlcnMlMjBjdXN0b218ZW58MHx8fHwxNzg4MjAzOTYwfDA&ixlib=rb-4.1.0&q=85",
    external: true,
  },
  {
    id: "ph-2",
    type: "image",
    title: "Fresque en cours",
    url: "https://images.unsplash.com/photo-1541753866388-0b3c701627d3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwxfHxhcnRpc3QlMjBwYWludGluZyUyMG11cmFsfGVufDB8fHx8MTc4ODIwMzk2MHww&ixlib=rb-4.1.0&q=85",
    external: true,
  },
  {
    id: "ph-3",
    type: "image",
    title: "Toile en live",
    url: "https://images.unsplash.com/photo-1584661156681-540e80a161d3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwyfHxhcnRpc3QlMjBwYWludGluZyUyMG11cmFsfGVufDB8fHx8MTc4ODIwMzk2MHww&ixlib=rb-4.1.0&q=85",
    external: true,
  },
  {
    id: "ph-4",
    type: "image",
    title: "Cuir customisé",
    url: "https://images.unsplash.com/photo-1694403456818-18d2c0d2f6aa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxwYWludGVkJTIwc25lYWtlcnMlMjBjdXN0b218ZW58MHx8fHwxNzg4MjAzOTYwfDA&ixlib=rb-4.1.0&q=85",
    external: true,
  },
  {
    id: "ph-5",
    type: "image",
    title: "Ambiance galerie",
    url: "https://images.unsplash.com/photo-1707047248533-7c45628379d6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBhcnQlMjBnYWxsZXJ5JTIwZGFya3xlbnwwfHx8fDE3ODgyMDM5NjF8MA&ixlib=rb-4.1.0&q=85",
    external: true,
  },
];
